export default __webpack_public_path__ + "static/media/curso_fitosanitarios_palencia.07e3a908.jpg";